import classNames from "classnames";
import React, { FC, useCallback } from "react";
import { useAppContext } from "../../../hooks/useAppContext";
import { Checkbox } from "../../checkbox";
import { IconButton } from "../../icon-button";
import { useUserDateDialogActions, useUserDateDialogState } from "./use-user-date-dialog-state";
import "./user-date-item.css";

export const UserDateItem: FC<Required<eXpress.core.IUserDate>> = ({ id, value, dateCode }) => {
	const {
		context: { language },
	} = useAppContext();
	const { selectedUserDateIds, selectedUserDateId } = useUserDateDialogState();

	const { deleteUserDate, setSelectedUserDateId, toggleUserDate, clearForm } =
		useUserDateDialogActions();

	const localDateString = new Date(
		2024, // hardcoded since we don't use/show the year anyway, but it has to be a leapyear or 29 feb will be shown as march 1
		eXpress.RecurringDateCode.getMonth(dateCode) - 1,
		eXpress.RecurringDateCode.getDay(dateCode),
	).toLocaleDateString(language, {
		month: "short",
		day: "numeric",
	});

	const isActive = selectedUserDateId === id;
	const isChecked = selectedUserDateIds.has(id);

	const onDelete = useCallback(() => {
		if (isActive) {
			clearForm();
		}
		deleteUserDate(id);
	}, [clearForm, deleteUserDate, id, isActive]);

	return (
		<div
			className={classNames("user-date-item", {
				"user-date-item--active": isActive,
			})}
		>
			<div className="user-date-item__cell">
				<Checkbox
					id={id}
					checked={isChecked}
					label={value}
					onChange={() => toggleUserDate(id)}
				/>
			</div>
			<div className="user-date-item__cell">{localDateString}</div>
			<div className="user-date-item__cell">
				<IconButton iconName="pencil" onClick={() => setSelectedUserDateId(id)} />
			</div>
			<div className="user-date-item__cell">
				<IconButton iconName="bin" onClick={onDelete} />
			</div>
		</div>
	);
};
